import { QueryClient, QueryClientConfig } from 'react-query';
import { RETRY_QUERY, RETRY_MUTATION, DEFAULT_STALE_TIME } from '../../../utils/constants';

const config: QueryClientConfig = {
    defaultOptions: {
        queries: {
            retry: RETRY_QUERY,
            staleTime: DEFAULT_STALE_TIME,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: RETRY_MUTATION,
        },
    },
};

const client = new QueryClient(config);

export { client };
